<template>
    <div class="ibox form">
        <div v-if="title" class="ibox-title ibox-grey">
            <h4>{{ title }}</h4>
            <slot name="tools">
                <button-open-help-modal :helpName="helpName"/>
            </slot>
        </div>

        <div class="ibox-content">
            <div :class="{'form-group m-b-sm': forForm}" class="row">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BaseBoxSection",
    props: {
        title: {
            type: String,
            default: '',
        },
        helpName: {
            type: String,
            default: '',
        },
        forForm: {
            type: Boolean,
            default: true,
        },
    },
};
</script>
